import React from 'react'

import lang from '@/lang'
import { CurrencyInput, IbanInput, TextInput, TextareaInput } from '@/modules/base/components/inputs'
import { useFormikContext } from 'formik'
import OCRWrapper from '@/modules/document/components/file-info/ocr-wrapper'
import { Document } from '@/modules/document/types'

const {
  documentPaymentDrawer: {
    intro,
    labels,
  },
} = lang

const dataQsIdPrefix = 'qrPaymentForm'

interface QRPaymentFormProps {
  classes,
  formik,
  setIbanValid: (v: boolean) => void,
  file: Document,
}

const QRPaymentForm = ({ classes, formik, setIbanValid, file }: QRPaymentFormProps) => {
  const onInputChange = (value, name) => {
    formik.setFieldValue(name, value)
  }

  const handleValidation = (isValid, bankData) => {
    setIbanValid(isValid)

    if (!isValid) {
      formik.setFieldValue('bic', '')
      return
    }

    const { bic } = bankData
    formik.setFieldValue('bic', bic)
  }

  useFormikContext()

  return (
    <div className={classes.form}>
      <span className={classes.intro}>{intro}</span>
      <OCRWrapper ocr={file.metaData?.ocr} ocrKey='payee'>
        <TextInput
          dataQsId={`${dataQsIdPrefix}-accountHolderInput`}
          name="accountHolder"
          label={labels.accountHolder}
          required
          value={formik.values.accountHolder}
          onChange={onInputChange}
          customClass={classes.inputWrapper}
        />
      </OCRWrapper>
      <OCRWrapper ocr={file.metaData?.ocr} ocrKey='payeeIban'>
        <IbanInput
          dataQsId={`${dataQsIdPrefix}-ibanInput`}
          name="iban"
          label={labels.iban}
          value={formik.values.iban}
          handleValidation={handleValidation}
          onInputChanged={onInputChange}
          customClass={classes.iban}
        />
      </OCRWrapper>
      <OCRWrapper ocr={file.metaData?.ocr} ocrKey='payeeBic'>
        <TextInput
          dataQsId={`${dataQsIdPrefix}-bicInput`}
          name="bic"
          label={labels.bic}
          value={formik.values.bic}
          onChange={onInputChange}
          customClass={classes.inputWrapper}
        />
      </OCRWrapper>
      <OCRWrapper ocr={file.metaData?.ocr} ocrKey='priceTotal'>
        <CurrencyInput
          customNumberError={formik.errors.totalAmount}
          customClass={classes.inputWrapper}
          useFormik={true}
          name="totalAmount"
          precision={2}
          label={labels.totalAmount }
          value={formik.values.totalAmount}
          onChange={onInputChange}
        />
      </OCRWrapper>
      <OCRWrapper ocr={file.metaData?.ocr} ocrKey='receiptNumber'>
        <TextareaInput
          dataQsId={`${dataQsIdPrefix}-purposeInput`}
          name="purpose"
          label={labels.purpose}
          className={classes.inputWrapper}
          rows={3}
          value={formik.values.purpose}
          onChange={onInputChange}
        />
      </OCRWrapper>
    </div>
  )
}

export default QRPaymentForm
